import {Condition} from './condition';

export class Location {
  public nodeId: string;
  public correlation: number;

  constructor(nodeId: string, correlation: number) {
    this.nodeId = nodeId;
    this.correlation = correlation;
  }

  public getConditionEFL(index: number, rank: number): Condition {
    let condition: Condition = Condition.NORMAL;
    // const rank = Config.rank;
    
    console.log("Rank: " + rank + " -- Index: " + index + " -- Prob: " + this.correlation);

    if (this.correlation > 1) {
      // throw new Error( this + ' has correlation = ' + this.correlation + ' > 1');
      console.error(this + ' has correlation = ' + this.correlation + ' > 1');
    }
    if (index > 0 && index < rank && this.correlation > 0) {
        condition = Condition.ATTENTION;
    }
    if (index === 0  && this.correlation > 0) {
        condition = Condition.PROBLEM;
    }
    return condition;
  }

  /* getConditionEFL(index: number, probability: number): Condition {
    console.log("method getConditionEFL call");
    let condition: Condition = Condition.NORMAL;
    const rank = this.rank;

    if (probability > 1) {
      throw new Error( this.locationArray[index] + 'has probability = ' + probability + ' > 1');
      console.error(this.locationArray[index] + 'has probability = ' + probability + ' > 1');
    }
    if (index > 0 && index < rank && probability > 0) {
      condition = Condition.ATTENTION;
    }
    if (index === 0  && probability > 0) {
      condition = Condition.PROBLEM;
    }
    return condition;
  }*/
}
